import useExtractor from '../../../shared/src/shared-stores/extractor';
import useApp from './app';
import useAssets from './assets';
import useAutoText from './auto-text';
import useBooks from './books';
import useCategory from './category';
import useCookies from './cookies';
import useCourse from './course';
import useCourseProgress from './course-progress';
import useCustomVocabulary from './custom-vocabulary';
import useError from './error';
import useFavorites from './favorites';
import useFeed from './feed';
import useFiles from './files';
import useGAnalytics from './g-analytics';
import useGrammar from './grammar';
import useGrammarProgress from './grammar-progress';
import useIntroMessage from './intro-message';
import useKeyControls from './key-control';
import useKlexikon from './klexikon';
import useLanguage from './language';
import useLiveConversations from './live-conversations';
import useProgress from './progress';
import useRequests from './requests';
import useSearch from './search';
import useSettings from './settings';
import useText from './text';
import useTooltip from './tooltip';
import useTourGuide from './tour-guide';
import useTranslate from './translate';
import useUser from './user';
import useVideo from './video';
import useWikipedia from './wikipedia';

export const user = useUser();
export const language = useLanguage();
export const settings = useSettings();
export const grammar = useGrammar();
export const grammarProgress = useGrammarProgress();
export const course = useCourse();
export const progress = useProgress();
export const courseProgress = useCourseProgress();
export const customVocabulary = useCustomVocabulary();
export const favorites = useFavorites();
export const error = useError();
export const tourGuide = useTourGuide();
export const requests = useRequests();
export const tooltip = useTooltip();
export const assets = useAssets();
export const app = useApp();
export const extractor = useExtractor();
export const text = useText();
export const video = useVideo();
export const wikipedia = useWikipedia();
export const feed = useFeed();
export const translate = useTranslate();
export const klexikon = useKlexikon();
export const liveConversations = useLiveConversations();
export const books = useBooks();
export const category = useCategory();
export const files = useFiles();
export const autoText = useAutoText();
export const introMessage = useIntroMessage();
export const cookies = useCookies();
export const gAnalytics = useGAnalytics();
export const keyControls = useKeyControls();
export const search = useSearch();

export default {
  requests,
  language,
  tooltip,
  settings,
  app,
  extractor,
  text,
  video,
  wikipedia,
  feed,
  favorites,
  translate,
  klexikon,
  liveConversations,
  books,
  category,
  error,
  tourGuide,
  progress,
  courseProgress,
  assets,
  files,
  user,
  autoText,
  introMessage,
  cookies,
  gAnalytics,
  course,
  grammar,
  keyControls,
  search,
  grammarProgress,
  customVocabulary
};
